<template>
  <div style="background-color: #f6f6f6;">
    <van-nav-bar title="我的提现" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <div>
      <van-cell-group>
        <van-field v-model="tixianMoney" label="提现金额" type="number"  placeholder="" />
        <van-field v-model="currentMoney" readonly label="可提现金额"  type="number" placeholder="" />
      </van-cell-group>
      <van-button size="large" type="danger" v-on:click="clickTixian()">确定提现</van-button>
      <div style="text-align:left;padding:10px;" v-on:click="$router.push('/article/detail/68')">提现说明</div>
    </div>
    <div class="list">
      <div class="item" v-for="item in list" :key="item.id" v-on:click="$toast(item.reason)">
        <div class="title">
          {{item.create_time}}
          <br />

          {{status[item.cashout_status]}} {{item.cashout_desc}}
        </div>
        <div class="price">提现金额：¥{{item.cashout_money}}</div>
      </div>
    </div>
    <div style="height:46px"></div>
    <TabBar active="4" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
export default {
  name: "money",
  components: {
    TabBar
  },
  data() {
    return {
      list: [],
      user: { token: "", user: {} },
      status: ["审核中", "审核成功", "审核拒绝"],
      tixianMoney:0,
      currentMoney:0,
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onLoad() {
      this.$http
        .get(this.GLOBAL.API + "finance/cashout/cashoutList", {
          params: { },
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;

          this.list = data.data; //= data.data.data;
        });
    },
    getCurrentMoney() {
      this.$http
        .get(this.GLOBAL.API + "s_user/balance/current", {
          params: {  },
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;

          this.currentMoney = data.data; //= data.data.data;
        });
    },
    clickTixian() {
      this.$http
        .post(this.GLOBAL.API + "finance/cashout/apply",{money:this.tixianMoney}, {
          params: {  },
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          this.$toast(data.msg);
          this.onLoad()
        });
    },

  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.onLoad();
      this.getCurrentMoney();
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  text-align: left;
  .item {
    background-color: #fff;
    display: flex;
    padding: 10px 10px 0 10px;
    margin-top: 10px;
    justify-content: space-between;

    .title {
      line-height: 20px;
      height: 40px;
      overflow: hidden;
      padding: 0 5px 0 5px;
    }
    .price {
      color: red;
      text-align: right;
      padding: 0 5px 0 5px;
    }
  }
}
</style>